import * as React from "react";
import {
  Box,
  Card,
  CardContent,
  CircularProgress,
  Grid,
  Typography,
  Link as MuiLink,
  useTheme,
  ToggleButton,
  ToggleButtonGroup,
  Button,
  Stack,
  Divider,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Avatar,
  LinearProgress,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Chip,
} from "@mui/material";
import Header from "../../components/Header";
import MainLogo from "../../components/MainLogo";
import { Link, useNavigate } from "react-router-dom";
import { tokens } from "../../theme";
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import PeopleOutlinedIcon from "@mui/icons-material/PeopleOutlined";
import HouseOutlinedIcon from "@mui/icons-material/HouseOutlined";
import CardMembershipOutlinedIcon from "@mui/icons-material/CardMembershipOutlined";
import NotificationsActiveOutlinedIcon from "@mui/icons-material/NotificationsActiveOutlined";
import AssignmentOutlinedIcon from "@mui/icons-material/AssignmentOutlined";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { PieChart, pieArcLabelClasses, LineChart } from "@mui/x-charts";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import {
  Group,
  Home,
  Build,
  Today,
  HomeWork,
  MonetizationOn,
  HistoryRounded,
  AlignHorizontalRight,
  KeyboardDoubleArrowRightSharp,
  People,
  LocationCityRounded,
  BuildOutlined,
  KeyboardArrowRightRounded,
  KeyboardDoubleArrowLeftRounded,
  KeyboardDoubleArrowLeftSharp,
} from "@mui/icons-material";

// require("dotenv").config();
import stringToColor from "../../services/stringToColor";
import { useTranslation } from "react-i18next";
const StatCard = ({ icon, title, value, rating }) => {
  const isPositive = rating > 0;

  return (
    <Paper
      elevation={2}
      sx={{
        px: 1,
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-evenly",
        borderRadius: 3,
        height: "10vh",
        borderBlockEndColor: "#cbd5e1",
      }}
    >
      <Box display="flex" alignItems="center" justifyContent={"space-evenly"}>
        <Box>{icon}</Box>
        <Box>
          <Typography variant="h7" color="text.secondary">
            {title}
          </Typography>
          <Stack direction="row" alignItems="center" spacing={1}>
            <Typography variant="h3" fontWeight={600} mr={2}>
              {value}
            </Typography>
            <Stack direction="row" alignItems="center" spacing={0.5} ml={2}>
              {isPositive ? (
                <ArrowUpwardIcon fontSize="small" color="success" />
              ) : (
                <ArrowDownwardIcon fontSize="small" color="error" />
              )}
              <Typography variant="h5" color={isPositive ? "green" : "red"}>
                {Math.abs(rating)}%
              </Typography>
            </Stack>
          </Stack>
        </Box>
      </Box>
    </Paper>
  );
};
const Dashboard = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [data, setData] = useState(null);
  const [activity, setActivity] = useState([]);
  const [chartData, setChartData] = useState([]);
  const [maintenanceData, setMaintenanceData] = useState([]);
  const [propertyData, setPropertyData] = useState([]);
  const [compoundUserStatus, setCompoundUserStatus] = useState([]);
  const [viewMode, setViewMode] = useState("all");
  const navigator = useNavigate();
  const { t, i18n } = useTranslation();
  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_BACKEND_URL}/api/admin/dashboardData`, {
        withCredentials: true,
      })
      .then((res) => setData(res.data));
    axios
      .get(
        `${process.env.REACT_APP_BACKEND_URL}/api/admin/dashboard/getActivityLogs`,
        {
          withCredentials: true,
        }
      )
      .then((res) => setActivity(res.data));
    axios
      .get(
        `${process.env.REACT_APP_BACKEND_URL}/api/admin/dashboard/userActivityChart`,
        {
          withCredentials: true,
        }
      )
      .then((res) => setChartData(res.data));
    axios
      .get(
        `${process.env.REACT_APP_BACKEND_URL}/api/admin/dashboard/maintenanceStatusPie`,
        {
          withCredentials: true,
        }
      )
      .then((res) => setMaintenanceData(res.data));
    axios
      .get(
        `${process.env.REACT_APP_BACKEND_URL}/api/admin/dashboard/propertyStatusPie`,
        {
          withCredentials: true,
        }
      )
      .then((res) => setPropertyData(res.data));
    axios
      .get(
        `${process.env.REACT_APP_BACKEND_URL}/api/admin/dashboard/getcompoundUserStatus`,
        {
          withCredentials: true,
        }
      )
      .then((res) => setCompoundUserStatus(res.data.resultData));
  }, []);
  const PIE_COLORS = [
    "#00E5A0", // Soft Green
    "#FFD600", // Soft Yellow
    "#FF6D00", // Orange
    "#536DFE", // Blue
    "#E040FB", // Purple
    "#FF4081", // Pink
    "#7C4DFF", // Violet
    "#FFC400", // Gold
    "#29B6F6", // Cyan
  ];

  if (!data || chartData.length === 0)
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="80vh"
      >
        <CircularProgress color="success" />
      </Box>
    );

  const getFilteredChart = () => {
    return chartData.map((point) => ({
      x: point.date,
      ...(viewMode === "all" || viewMode === "total"
        ? { total: point.total }
        : {}),
      ...(viewMode === "all" || viewMode === "active"
        ? { active: point.active }
        : {}),
      ...(viewMode === "all" || viewMode === "inactive"
        ? { inactive: point.inactive }
        : {}),
      ...(viewMode === "all" || viewMode === "pending"
        ? { pending: point.pending }
        : {}),
    }));
  };
  return (
    <Box m="0px 20px 20px 20px">
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={2}
      >
        <MainLogo />
      </Box>
      <Box sx={{}}>
        <Grid container columns={{ xs: 2, sm: 8, md: 12 }} spacing={2}>
          <Grid item size={{ xs: 2, sm: 5, md: 8 }}>
            <Grid container columns={{ xs: 2, sm: 10, md: 12 }} spacing={2}>
              <Grid item size={{ xs: 2, sm: 2, md: 3 }}>
                <StatCard
                  icon={<People fontSize="large" />}
                  title="Total Users"
                  value={data?.users.total}
                  rating={data?.users.rating}
                />
              </Grid>
              <Grid item size={{ xs: 2, sm: 2, md: 3 }}>
                <StatCard
                  icon={<LocationCityRounded fontSize="large" />}
                  title="Total Units"
                  value={data?.units.total}
                  rating={data?.units.rating}
                />
              </Grid>
              <Grid item size={{ xs: 2, sm: 2, md: 3 }}>
                <StatCard
                  icon={<BuildOutlined fontSize="large" />}
                  title="Total Maintenace Requests"
                  value={data?.requests.total}
                  rating={data?.requests.rating}
                />
              </Grid>
              <Grid item size={{ xs: 2, sm: 2, md: 3 }}>
                <StatCard
                  icon={<MonetizationOn fontSize="large" />}
                  title="Total Payment"
                  value={data?.payments.total}
                  rating={data?.payments.rating}
                />
              </Grid>
              <Grid item size={{ xs: 2, sm: 2, md: 4 }}>
                <Paper
                  sx={{
                    border: "1px",
                    height: "50vh",
                    p: 2,
                    display: "flex",
                    flexDirection: "column",
                  }}
                  elevation={3}
                >
                  <Box display="flex" justifyContent="space-between" mb={1}>
                    <Box display="flex" alignItems="center">
                      <HistoryRounded />
                      <Typography variant="h5" ml={2}>
                        Activity Logs
                      </Typography>
                    </Box>
                    <Button
                      variant="inline"
                      endIcon={
                        theme.direction === "rtl" ? (
                          <KeyboardDoubleArrowLeftSharp />
                        ) : (
                          <KeyboardDoubleArrowRightSharp />
                        )
                      }
                      onClick={() => navigator("/logs")}
                    >
                      more
                    </Button>
                  </Box>
                  <Divider />
                  <Box sx={{ overflowY: "auto" }}>
                    <List>
                      {activity.length > 0 ? (
                        activity.map((log) => (
                          <>
                            <ListItem key={log.id}>
                              <ListItemIcon className="notranslate">
                                {log.user.avatar_url ? (
                                  <Avatar
                                    alt={log.user.username}
                                    src={log.user.avatar_url}
                                  />
                                ) : (
                                  <Avatar
                                    sx={{
                                      bgcolor: stringToColor(log.user.FullName),
                                    }}
                                  >
                                    {log.user.FullName.charAt(0).toUpperCase()}
                                  </Avatar>
                                )}
                              </ListItemIcon>
                              <ListItemText
                                primary={
                                  <React.Fragment>
                                    <Box display="flex" className="notranslate">
                                      <Typography
                                        variant="h5"
                                        className="notranslate"
                                      >
                                        {log.user.username}
                                      </Typography>
                                      <Typography
                                        sx={{
                                          color: "text.primary",
                                          display: "inline",
                                          marginLeft: "10px",
                                          overflow: "hidden",
                                          textOverflow: "ellipsis",
                                          whiteSpace: "nowrap",
                                        }}
                                        variant="h7"
                                      >
                                        ({log.user.phone})
                                      </Typography>
                                    </Box>
                                  </React.Fragment>
                                }
                                secondary={
                                  <React.Fragment>
                                    <Box display="flex">
                                      <Typography
                                        sx={{
                                          color: "text.primary",
                                          display: "-webkit-box",
                                          overflow: "hidden",
                                          textOverflow: "ellipsis",
                                          WebkitBoxOrient: "vertical",
                                          WebkitLineClamp: 2,
                                        }}
                                        variant="h7"
                                      >
                                        {log.description}
                                      </Typography>
                                    </Box>
                                  </React.Fragment>
                                }
                              />
                            </ListItem>
                            <Divider variant="inset" />
                          </>
                        ))
                      ) : (
                        <ListItem>
                          <ListItemText primary="📭 No activity logs." />
                        </ListItem>
                      )}
                    </List>
                  </Box>
                </Paper>
              </Grid>
              <Grid item size={{ xs: 2, sm: 12, md: 8 }}>
                <Paper
                  sx={{
                    border: "1px",
                    height: "50vh",
                    p: 3,
                    borderBlockEndColor: "#cbd5e1",
                  }}
                  elevation={3}
                >
                  <Box>
                    <Box
                      display="flex"
                      justifyContent="space-between"
                      mb={2}
                      sx={{ overflow: "auto" }}
                    >
                      <Typography variant="h6">
                        User Status (Last 20 Days)
                      </Typography>
                      <ToggleButtonGroup
                        value={viewMode}
                        onChange={(e, val) => val && setViewMode(val)}
                        exclusive
                        size="small"
                      >
                        <ToggleButton value="all">All</ToggleButton>
                        <ToggleButton value="total">Total</ToggleButton>
                        <ToggleButton value="active">Active</ToggleButton>
                        <ToggleButton value="inactive">Inactive</ToggleButton>
                        <ToggleButton value="pending">Pending</ToggleButton>
                      </ToggleButtonGroup>
                    </Box>
                    <LineChart
                      xAxis={[
                        {
                          scaleType: "point",
                          data: getFilteredChart().map((d) => d.x),
                          tickLabelStyle: { fill: "#b3b8c4", fontSize: 14 },
                        },
                      ]}
                      series={Object.keys(getFilteredChart()[0] || {})
                        .filter((k) => k !== "x")
                        .map((key, idx) => {
                          // Assign unique gradient and color per series
                          const colors = [
                            "#fde047",
                            "#60a5fa",
                            "#f472b6",
                            "#8b5cf6",
                            "#f87171",
                          ];
                          const gradIds = [
                            "yellow-grad",
                            "blue-grad",
                            "red-grad",
                            "purple-grad",
                            "pink-grad",
                          ];
                          return {
                            data: getFilteredChart().map((d) => d[key]),
                            label: t(`dashboard.${key}`),
                            area: true,
                            curve: "catmullRom",
                            showMark: false,
                            color: colors[idx % colors.length],
                            // fill: `url(#${gradIds[idx % gradIds.length]})`,
                          };
                        })}
                      height={280}
                      grid={{ horizontal: true, vertical: false }}
                      sx={{
                        // background: "#181D2F",
                        ".MuiLineElement-root": { strokeWidth: 1 },
                        ".MuiAreaElement-root": { opacity: 0.1 },
                        ".MuiChartsAxis-root text": { fill: "#b3b8c4" },
                        ".MuiChartsLegend-root": { color: "#fff" },
                      }}
                      slotProps={{
                        legend: {
                          hidden: false,
                          labelStyle: { color: "#fff" },
                        },
                      }}
                    />

                    {/* <LineChart
                      xAxis={[
                        {
                          scaleType: "point",
                          data: getFilteredChart().map((d) => d.x),
                        },
                      ]}
                      series={Object.keys(getFilteredChart()[0] || {})
                        .filter((k) => k !== "x")
                        .map((key) => ({
                          data: getFilteredChart().map((d) => d[key]),
                          label: key.charAt(0).toUpperCase() + key.slice(1),
                          area: true, // fill under the line
                          curve: "catmullRom",
                          showMark: false,
                        }))}
                      height={300}
                      grid={{ horizontal: true }}
                      sx={{
                        ".MuiLineElement-root": { strokeWidth: 1 },
                        ".MuiAreaElement-root": {
                          fill: "url(#rpm-gradient)",
                          opacity: 0.75,
                        },
                      }}
                    /> */}
                  </Box>
                </Paper>
              </Grid>
            </Grid>
          </Grid>
          <Grid item size={{ xs: 2, sm: 3, md: 4 }}>
            <Grid container columns={{ xs: 2, sm: 10, md: 12 }} spacing={2}>
              <Grid item size={{ xs: 2, sm: 10, md: 12 }}>
                <Paper
                  sx={{
                    border: "1px",
                    height: "30vh",
                    p: 2,
                    // background: "#171B24", // Modern dark background (optional)
                    borderRadius: 4,
                    boxShadow: 6,
                  }}
                  elevation={3}
                >
                  <Typography variant="h6" mb={2}>
                    Maintenance Status
                  </Typography>
                  <PieChart
                    series={[
                      {
                        data: maintenanceData.map((d, idx) => ({
                          id: d.status,
                          value: d.count,
                          color: PIE_COLORS[idx % PIE_COLORS.length], // Assign custom color
                          label: t(`dashboard.${d.status.toLowerCase()}`),
                          // label: t(`dashboard.${d.status.replace(/_/g, "")}`),
                        })),
                        innerRadius: 62, // Donut style
                        outerRadius: 95, // A bit fatter arcs
                        cornerRadius: 8, // Rounded corners for soft style
                        paddingAngle: 2.5, // Gaps between slices
                      },
                    ]}
                    slotProps={{
                      legend: {
                        labelStyle: {
                          color: "#fff",
                          fontSize: 12,
                          fontWeight: 700,
                        },
                      },
                    }}
                    width={410}
                    height={220}
                    sx={{
                      borderRadius: 4,
                      [`& .${pieArcLabelClasses.root}`]: {
                        fill: "#fff",
                        fontWeight: 600,
                        fontSize: 14,
                        filter: "drop-shadow(0 0 4px #222a)",
                      },
                      [`& .MuiChartsLegend-root`]: {
                        mt: 3,
                      },
                    }}
                  />
                </Paper>
                {/* <Paper
                  sx={{
                    border: "1px",
                    height: "30vh",
                    p: 2,
                    borderBlockEndColor: "#cbd5e1",
                  }}
                  elevation={3}
                >
                  <Typography variant="h6" mb={2}>
                    Maintenance Status
                  </Typography>
                  <PieChart
                    series={[
                      {
                        data: maintenanceData.map((d) => ({
                          id: d.status,
                          value: d.count,
                          label: d.status.replace(/_/g, " ").toUpperCase(),
                        })),
                        innerRadius: 50,
                      },
                    ]}
                    width={500}
                    height={200}
                    // sx={{
                    //   [`& .${pieArcLabelClasses.root}`]: {
                    //     fill: "#fff",
                    //     fontSize: 12,
                    //   },
                    // }}
                  />
                </Paper> */}
              </Grid>
              <Grid item size={{ xs: 2, sm: 10, md: 12 }}>
                <Paper
                  sx={{
                    border: "1px",
                    height: "30vh",
                    p: 2,
                    borderBlockEndColor: "#cbd5e1",
                  }}
                  elevation={3}
                >
                  <Typography variant="h6" mb={2}>
                    Property Status
                  </Typography>
                  <PieChart
                    series={[
                      {
                        data: propertyData.map((d, idx) => ({
                          id: d.status,
                          value: d.count,
                          color: PIE_COLORS[idx % PIE_COLORS.length],
                          label: t(`dashboard.${d.status.toLowerCase()}`),
                          // label: d.status.replace(/_/g, " ").toUpperCase(),
                        })),
                        innerRadius: 42, // Donut style
                        outerRadius: 75, // A bit fatter arcs
                        cornerRadius: 8, // Rounded corners for soft style
                        paddingAngle: 2.5, // Gaps betw
                      },
                    ]}
                    slotProps={{
                      legend: {
                        labelStyle: {
                          color: "#fff",
                          fontSize: 12,
                          fontWeight: 700,
                        },
                      },
                    }}
                    width={410}
                    height={220}
                    sx={{
                      borderRadius: 4,
                      [`& .${pieArcLabelClasses.root}`]: {
                        fill: "#fff",
                        fontWeight: 600,
                        fontSize: 14,
                        filter: "drop-shadow(0 0 4px #222a)",
                      },
                      [`& .MuiChartsLegend-root`]: {
                        mt: 3,
                      },
                    }}
                  />
                </Paper>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default Dashboard;
